import React from 'react'

import type { WaveLinkHeaderContentBlock } from '@library/api-menu-experience'
import { WaveLinkHeader } from '@library/menu-page'

type WaveLinkHeaderContentBlockWrapperProps = {
  contentBlock: WaveLinkHeaderContentBlock
}

const onClick = () => {}

export const WaveLinkHeaderContentBlockWrapper = ({
  contentBlock,
}: WaveLinkHeaderContentBlockWrapperProps) => (
  <WaveLinkHeader contentBlock={contentBlock} onClick={onClick} />
)
